/*
 * @创建文件时间: 2020-04-19 00:02:47
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-04 21:45:52
 * @联系Qq:1638245306
 * @文件介绍:
 */
/*
 * @创建文件时间: 2019-11-03 16:13:07
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-04 21:41:33
 * @联系Qq:1638245306
 * @文件介绍:
 */
export default {
    // 快捷键
    // 支持快捷键 例如 ctrl+shift+s
    hotkey: {
        search: {
            // open: 's',
            // close: 'esc'
        }
    },
    // 侧边栏默认折叠状态
    menu: {
        asideCollapse: true
    },
    // 在读取持久化数据失败时默认页面
    page: {
        opened: [{
            name: 'index',
            fullPath: '/index',
            meta: {
                title: '首页',
                auth: false
            }
        }]
    },
    // 菜单搜索
    search: {
        enable: false
    },
    // 注册的主题
    theme: {
        list: [{
                title: 'admin经典',
                name: 'd2',
                // backgroundImage: 'image/theme/glj/bg.png',
                preview: 'image/theme/d2/preview@2x.png'
            },
            {
                title: '甘肃省公路局定制',
                name: 'glj',
                // backgroundImage: 'image/theme/glj/bg.png',
                preview: 'image/theme/glj/preview@2x.png'
            },
            {
                title: '紫罗兰',
                name: 'violet',
                preview: 'image/theme/violet/preview@2x.png'
            },
            {
                title: '简约线条',
                name: 'line',
                backgroundImage: 'image/theme/line/bg.jpg',
                preview: 'image/theme/line/preview@2x.png'
            },
            {
                title: '流星',
                name: 'star',
                backgroundImage: 'image/theme/star/bg.jpg',
                preview: 'image/theme/star/preview@2x.png'
            },
            {
                title: 'Tomorrow Night Blue (vsCode)',
                name: 'tomorrow-night-blue',
                preview: 'image/theme/tomorrow-night-blue/preview@2x.png'
            }
        ]
    },
    // 是否默认开启页面切换动画
    transition: {
        active: true
    }
}
